import { createSlice, PayloadAction } from "@reduxjs/toolkit";

const currentSelectedSidebarCellSlice = createSlice({
  name: "currentSelectedSidebarCell",
  initialState: "",
  reducers: {
    setSidebarSelectedCell: (_state: any, action: PayloadAction<any>) => action.payload,
  },
});

const showStickySidebarSlice = createSlice({
  name: "showStickySidebar",
  initialState: "",
  reducers: {
    setShowStickySidebar: (_state: any, action: PayloadAction<any>) => action.payload,
  },
});

export const { setSidebarSelectedCell } = currentSelectedSidebarCellSlice.actions;
export const { setShowStickySidebar } = showStickySidebarSlice.actions;

export const currentSelectedSidebarCell = currentSelectedSidebarCellSlice.reducer;
export const showStickySidebar = showStickySidebarSlice.reducer;

export default {
  currentSelectedSidebarCell: currentSelectedSidebarCellSlice.reducer,
  showStickySidebar: showStickySidebarSlice.reducer,
};
